import {
  ApiUTMEntityLevel,
  SyncServiceUpdateSmartLinkSettingsServiceEnum,
} from "@incendium/api";
import { syncService } from "Apis";

/**
 * Updates a smart link setting for a single entity
 */
export const updateSmartLink = async (
  projectId: number,
  level: ApiUTMEntityLevel,
  entityId: number,
  landingPathId?: number | null,
  rezonateUrl?: string,
  classificationItemIds?: number[],
  splitCampaignId?: number | null
): Promise<void> => {
  await syncService.syncServiceUpdateSmartLinkSettings({
    projectId,
    service: SyncServiceUpdateSmartLinkSettingsServiceEnum.FACEBOOK,
    body: {
      level,
      entityId,
      landingPathId: landingPathId !== undefined ? (landingPathId === null ? (null as any) : landingPathId) : undefined,
      rezonateUrl: rezonateUrl !== undefined ? rezonateUrl : undefined,
      classificationItemIds: classificationItemIds !== undefined ? classificationItemIds : undefined,
      splitCampaignId: splitCampaignId !== undefined ? (splitCampaignId === null ? (null as any) : splitCampaignId) : undefined,
    },
  });
};

